module.exports = __webpack_public_path__ + "img/b4.53e18769.jpg";